var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loading)?_c('LoadingContainer'):_c('router-view',{attrs:{"portal":_vm.portal,"block-drivers":_vm.blockDrivers,"layout-categories":_vm.layoutCategories}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }